import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|memoryEntryId|authorMemberId|memberId|ownerMemberId|creatorMemberId|nextCursorMemoryEntryId|journeyDayId|activityId|mediaId|conversationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function withQuery(url, params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${url}?${qs}` : url;
}

/** Private Journey Memory / Journal — Memory Context only (no Social publish / media). */
export const journeyMemoryApi = {
  list: (journeyId, params = {}) => travelClient.get(
    withQuery(travelEndpoints.journeyMemories(journeyId), params),
    snowflakeJson,
  ),
  listMine: (journeyId, params = {}) => travelClient.get(
    withQuery(travelEndpoints.journeyMemoriesMine(journeyId), params),
    snowflakeJson,
  ),
  get: (journeyId, memoryEntryId) => travelClient.get(
    travelEndpoints.journeyMemory(journeyId, memoryEntryId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyMemories(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, memoryEntryId, body) => travelClient.patch(
    travelEndpoints.journeyMemory(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
  changeVisibility: (journeyId, memoryEntryId, body) => travelClient.post(
    travelEndpoints.journeyMemoryVisibility(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
  hide: (journeyId, memoryEntryId, body) => travelClient.post(
    travelEndpoints.journeyMemoryHide(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
  restore: (journeyId, memoryEntryId, body) => travelClient.post(
    travelEndpoints.journeyMemoryRestore(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
  delete: (journeyId, memoryEntryId, body) => travelClient.post(
    travelEndpoints.journeyMemoryDelete(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
  shareToChat: (journeyId, memoryEntryId, body = { confirm: true }) => travelClient.post(
    travelEndpoints.journeyMemoryChatShare(journeyId, memoryEntryId),
    body,
    snowflakeJson,
  ),
};
